import { defineComponent, ref } from 'vue';
import { useSession } from '@/use/session';
import { useUsersCompanies } from '@/use/users-companies';
import { CURRENT_SUBDOMAIN, DEFAULT_SUBDOMAIN, HIGHER_SUBDOMAIN } from '@/constants/env';
export default defineComponent({
  beforeRouteEnter: async (to, from, next) => {
    const {
      session,
      createSubdomainURL,
      logout
    } = useSession();
    const {
      getUserCompanies
    } = useUsersCompanies();
    if (session.loggedIn) {
      try {
        if (CURRENT_SUBDOMAIN === DEFAULT_SUBDOMAIN || CURRENT_SUBDOMAIN === HIGHER_SUBDOMAIN) {
          var _session$loggedUser, _res$companies;
          const res = await getUserCompanies({
            page: 1,
            perPage: 1,
            q: {
              id_eq: session === null || session === void 0 ? void 0 : (_session$loggedUser = session.loggedUser) === null || _session$loggedUser === void 0 ? void 0 : _session$loggedUser.company_id
            }
          });
          const subdomain = res === null || res === void 0 ? void 0 : (_res$companies = res.companies) === null || _res$companies === void 0 ? void 0 : _res$companies[0].subdomain;
          window.location.replace(createSubdomainURL(subdomain, session.loggedUser.landing_page));
        } else {
          next(session.loggedUser.landing_page);
        }
      } catch (err) {
        console.error(err);
        logout();
        next('/login');
      }
    } else {
      next();
    }
  },
  layout: 'public',
  setup: () => {
    const canSignIn = ref(false);
    const loginType = ref('password');
    return {
      canSignIn,
      loginType
    };
  }
});